export default "Bringen";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/1/type/vacation/booked/yes/who-booked/self/documents/bring/answer.js